import { useState, useEffect } from "react";
import { portfolioListData } from "../../data";
import CustomModal from "../modal/CustomModal";
import PortfolioList from "../portfoliolist/PortfolioList";
import "./portfolio.scss";

export default function Portfolio() {
  const [selected, setSelected] = useState("featured");
  const [projects, setProjects] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    let selectedProjects = portfolioListData.find(
      (item) => item.id === selected
    ).projects;
    setProjects(selectedProjects);
  }, [selected]);

  const onItemClick = (item) => {
    setSelectedProject(item);
    handleShow();
  };

  return (
    <div className="portfolio" id="portfolio">
      <CustomModal show={show} onHide={handleClose} item={selectedProject} />
      <h1>Portfolio</h1>
      <ul>
        {portfolioListData.map((item) => (
          <PortfolioList
            id={item.id}
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
          />
        ))}
      </ul>
      <span>Click on tiles to see more details</span>
      <div className="container">
        {projects?.map((item) => {
          return (
            <div className="item" onClick={() => onItemClick(item)}>
              <img src={item?.img} alt="" />
              <h3>{item?.title}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
}
